import React, { useEffect } from 'react'
import Highcharts from 'highcharts';
require('highcharts/modules/accessibility')(Highcharts);

export default function OrderingAccuracyChart({ summaryReports }) {
     function applyAccessibility(chart) {
      if (chart && chart.renderTo) {
      const svg = chart.renderTo.querySelector("svg.highcharts-root");
      if (svg) {
        setTimeout(() => {
          svg.setAttribute("role", "img");
          svg.setAttribute(
          "aria-label",
          "Ordering Accuracy pie chart showing the proportion of inventory orders that were above, on target, or below the EOQ. Most orders were classified as high."
          );

          const oldDesc = svg.querySelector("desc");
          if (oldDesc) oldDesc.remove();

          const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
          desc.textContent =
          "This chart shows the accuracy of inventory ordering against the Economic Order Quantity (EOQ). The pie chart indicates that the majority of orders were classified as high, meaning quantities ordered were greater than 1.2 times the EOQ.";
          svg.insertBefore(desc, svg.firstChild);
        },0);
      }
      }
    }
    var chart = {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        events: { 
        render: function () {
            applyAccessibility(this);
        },
        redraw: function () {
            applyAccessibility(this);
        }
      }
    };
    var title = {
        text: null,
        // align: 'left',
        // y: 17,
        // style: {
        //     fontSize: "14px",
        //     color: "#002D5F",
        // }
    };
    var credits = {
        enabled: false // Disable the Highcharts bottom link
    };
    var tooltip = {
        pointFormat: '<strong>{point.percentage:.2f}%</strong>'
    };
    var legend = {
        // align: 'left',
        // verticalAlign: 'bottom',
        // x: 0,
        // y: 0
    };

    var plotOptions = {
        pie: {
            // center: [130, 100],
            dataLabels: {
                enabled: false
            },
            showInLegend: false,
        }
    };
    var series = [{
        type: 'pie',
        data: [
            {
                name: 'No Order',
                y: (summaryReports?.OrderAnalysis?.OderingAccuracy?.Normal == 0 && summaryReports?.OrderAnalysis?.OderingAccuracy?.High == 0 && summaryReports?.OrderAnalysis?.OderingAccuracy?.Low == 0) ? 100 : 0,
                color: {
                    pattern: {
                      path: 'M 0 0 L 10 10', // Simple diagonal line
                      width: 10,
                      height: 10,
                      color: '#FFFFFF', // Line color (white)
                      backgroundColor: 'rgb(18, 178, 166)',
                    }
                  }
            },
            {
                name: 'On Target',
                y: summaryReports?.OrderAnalysis?.OderingAccuracy?.Normal,
                color: {
                    pattern: {
                      path: 'M 5 0 L 5 10', // Vertical line
                      width: 10,
                      height: 10,
                      color: '#FFFFFF', // Line color (white)
                      backgroundColor: 'rgb(0, 48, 87)' 
                    }
                  }
            },
            {
                name: 'High',
                y: summaryReports?.OrderAnalysis?.OderingAccuracy?.High,
                color: {
                    pattern: {
                      path: 'M 0 0 L 10 10 M 0 10 L 10 0', // Diagonal cross pattern
                      width: 10,
                      height: 10,
                      color: 'rgb(210, 219, 14)',
                    }
                  },
            },
            {
                name: 'Low',
                y: summaryReports?.OrderAnalysis?.OderingAccuracy?.Low,
                color: {
                    pattern: {
                        path: 'M 0 5 L 10 5', // Horizontal line
                        width: 10,
                        height: 10,
                        color: '#FFFFFF', // Line color (white)
                        backgroundColor: 'rgb(80, 87, 89)' // Background color (red)
                    }
                  }
            }
        ],
        states: {
            inactive: {
                enabled: false
            }
        }
    }];
    var accessibility = {
        enabled: true,
        screenReaderSection: {
        beforeChartFormat: '' // disables their auto "Interactive chart" label
      }
    }
    var json = {};
    json.chart = chart;
    json.credits = credits;
    json.title = title;
    json.tooltip = tooltip;
    json.legend = legend;
    json.series = series;
    json.plotOptions = plotOptions;
    json.accessibility = accessibility;
    const initGraph = () => {
        let chart = Highcharts.chart("container1", json);
        //console.log(chart)
    }
    useEffect(() => {
        initGraph();
    }, [summaryReports]);
    return (
        <div id="container1" style={{ height: "300px" }} title='Chart' aria-label='Ordering Accuracy Chart'></div>
    )
}
